import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitLabelBase } from '@/fo/ui/kit/label/base';
import { UiKitLabelBrand } from '@/fo/ui/kit/label/brand';
import { UiKitPriceBase } from '@/fo/ui/kit/price/base';

import { GroupedProduct } from '../../types';

import { styles } from './Grouped.styles';

type NativeElement = React.HTMLAttributes<HTMLDivElement>;

export interface GroupedProps {
  product: GroupedProduct;
  isInCart?: boolean;
  onAddToCart?: NativeElement['onClick'];
}

export function Grouped({ product, isInCart, onAddToCart }: GroupedProps) {
  const t = useTranslations();

  const slots = styles({ isInCart });

  const { image, title, subtitle, alt, labels, brandLabels, prices } = product;

  return (
    <div className={slots.base()}>
      <div className={slots.imageWrapper()}>
        {image && (
          <Image
            className={slots.image()}
            alt={alt || 'packshot'}
            width="680"
            height="318"
            src={image}
          />
        )}

        {(labels || brandLabels) && (
          <div className={slots.labels()}>
            {labels?.map(({ name, color }) => {
              return (
                <UiKitLabelBase
                  key={name}
                  customColor={color}
                  uppercase
                  size="l"
                >
                  {name}
                </UiKitLabelBase>
              );
            })}
            {brandLabels?.map(({ color, name, url }) => {
              return (
                <UiKitLabelBrand
                  key={name}
                  color={color}
                  url={url}
                  size="l"
                >
                  {name}
                </UiKitLabelBrand>
              );
            })}
          </div>
        )}
      </div>

      <div className={slots.contentWrapper()}>
        <div className={slots.text()}>
          <div className={slots.title()}>{title}</div>
          {subtitle && (
            <div
              className={slots.subtitle()}
              dangerouslySetInnerHTML={{ __html: subtitle }}
              suppressHydrationWarning
            />
          )}
        </div>

        {prices && prices.price !== null && prices?.price > 0 && (
          <div
            className={slots.commerce()}
            onClick={onAddToCart}
          >
            <UiKitPriceBase
              value={prices.price}
              oldValue={prices.oldPrice}
              className={slots.prices()}
              classNameValue={slots.price()}
              classNameOldValue={slots.oldPrice()}
            />

            <UiKitButtonBase className={slots.button()}>
              {isInCart ? t('addedToCart') : t('BuyGrouped')}
            </UiKitButtonBase>
          </div>
        )}
      </div>
    </div>
  );
}
